<template>
  <el-card class="tree-card">
    <div class="room-tree-title">房屋结构</div>
    <el-tree ref="tree" :data="treeData" node-key="id" :props="defaultProps" :highlight-current="true"
      :expand-on-click-node="false" @node-click="handleNodeClick">
      <span slot-scope="{ node, data }" class="custom-tree-node">
        <i :class="structureIcon(data)" class="tree-node-icon"></i>
        <span class="tree-node-label">{{ structureLabel(data, node.label) }}</span>
      </span>
    </el-tree>
  </el-card>
</template>

<script>
import { queryCommunityFloorTree } from '@/api/fee/adminOweFeeDetailApi'

export default {
  name: 'CommunityFloorTree',
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      callName: ''
    }
  },
  mounted() {
    this.initCommunityFloorTree()
  },
  methods: {
    async initCommunityFloorTree() {
      await this.loadCommunityFloorTree()
    },
    async loadCommunityFloorTree() {
      try {
        // 这里应该是从API获取树形数据
       const {data} = await queryCommunityFloorTree()
       console.log(data)
        // 模拟数据
        this.treeData = data
      } catch (error) {
        console.error(error)
      }
    },
    handleNodeClick(data) {
      if (data.id.startsWith('c_')) {
        this.$emit('chooseFloor', {
          communityName: data.communityName,
          communityId: data.communityId,
          floorNum: '',
          floorId: ''
        })
      } else if (data.id.startsWith('f_')) {
        this.$emit('chooseFloor', {
          communityName:'',
          communityId: '',
          floorNum: data.floorNum,
          floorId: data.floorId
        })
      }
    },
    structureLabel(data, fallback) {
      if (data.id && data.id.startsWith('f_')) return this.structureSuffix(data.floorNum || fallback, '号楼')
      return fallback
    },
    structureSuffix(value, suffix) {
      const text = String(value || '').trim()
      return text.endsWith(suffix) ? text : `${text}${suffix}`
    },
    structureIcon(data) {
      if (data.id && data.id.startsWith('c_')) return 'el-icon-location-outline'
      if (data.id && data.id.startsWith('f_')) return 'el-icon-office-building'
      return 'el-icon-document'
    }
  }
}
</script>

<style scoped>
.tree-card {
  max-height: 80vh;
  overflow-y: auto;
}
.room-tree-title {
  padding: 0 0 8px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #1f2d3d;
}
.tree-card ::v-deep .el-card__body {
  padding: 12px 8px;
}
.tree-card ::v-deep .el-tree-node__content {
  height: 32px;
  margin-bottom: 2px;
  border-radius: 4px;
}
.tree-card ::v-deep .el-tree-node__content:hover {
  background: #edf4fb;
}
.tree-card ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #fff;
  background: #149582;
}
.tree-card ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content .tree-node-icon,
.tree-card ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content .el-tree-node__expand-icon {
  color: #fff;
}
.custom-tree-node {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.tree-node-icon {
  margin-right: 6px;
  color: #6d86a8;
}
.tree-node-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
